
// import type { Action } from './types';

export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCHING_INVOICES = 'FETCHING_INVOICES';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILED = 'FETCH_INVOICES_FAILED';

export const FETCH_INVOICE = 'FETCH_INVOICE';
export const FETCHING_INVOICE = 'FETCHING_INVOICE';
export const FETCH_INVOICE_SUCCESS = 'FETCH_INVOICE_SUCCESS';
export const FETCH_INVOICE_FAILED = 'FETCH_INVOICE_FAILED';

export function fetchInvoices() {
  return {
    type: FETCH_INVOICES,
  };
}

export function fetchingInvoices() {
  return {
    type: FETCHING_INVOICES,
  };
}

export function fetchInvoicesSuccess(invoices) {
  return {
    type: FETCH_INVOICES_SUCCESS,
    invoices,
  };
}
export function fetchInvoicesFailed(error) {
  return {
    type: FETCH_INVOICES_FAILED,
    error,
  };
}

export function fetchInvoice(invoiceId) {
  return {
    type: FETCH_INVOICE,
    invoiceId,
  };
}

export function fetchingInvoice(invoiceId) {
  return {
    type: FETCHING_INVOICE,
    invoiceId,
  };
}

export function fetchInvoiceSuccess(invoice) {
  return {
    type: FETCH_INVOICE_SUCCESS,
    invoice,
  };
}

export function fetchInvoiceFailed(invoiceId, error) {
  return {
    type: FETCH_INVOICE_FAILED,
    invoiceId,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/actions/billing.js